import { defineComponent as o, openBlock as r, createBlock as n, normalizeProps as a, guardReactiveProps as p, withCtx as s, renderSlot as l, createElementVNode as c } from "vue";
import i from "../CdrIcon.vue.mjs";
const m = /* @__PURE__ */ c("path", {
  role: "presentation",
  d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm4 9H8a1 1 0 000 2h8a1 1 0 000-2z"
}, null, -1), _ = /* @__PURE__ */ o({
  name: "MinusFill",
  __name: "minus-fill",
  props: {
    props: {
      type: Object
    }
  },
  setup(e) {
    return (t, d) => (r(), n(i, a(p(e.props)), {
      default: s(() => [l(t.$slots, "default"), m]),
      _: 3
    }, 16));
  }
});
export {
  _ as default
};
